import { render } from "./LogoutNotificationModal.vue?vue&type=template&id=25153384&scoped=true"
import script from "./LogoutNotificationModal.vue?vue&type=script&lang=js"
export * from "./LogoutNotificationModal.vue?vue&type=script&lang=js"

import "./LogoutNotificationModal.vue?vue&type=style&index=0&id=25153384&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25153384"]])

export default __exports__